import React, { useState } from "react"

// The content endpoint returns the text "Not Found" (not a png) when a screen has
// no stored image, so treat short bodies as not an image.
const isImageData = value =>
  typeof value === "string" && value.length > 100

const srcFor = item =>
  isImageData(item && item.img) ? `data:image/png;base64,${item.img}` : null

const ImageModal = props => {
  const refs = Array.isArray(props.refs) ? props.refs : []
  const [activeIndex, setActiveIndex] = useState(null)

  const openViewer = index => {
    if (srcFor(refs[index])) {
      setActiveIndex(index)
    }
  }
  const backToGrid = () => setActiveIndex(null)
  const showPrev = () =>
    setActiveIndex(i => (i > 0 ? i - 1 : refs.length - 1))
  const showNext = () =>
    setActiveIndex(i => (i < refs.length - 1 ? i + 1 : 0))

  // Single-screen view.
  if (activeIndex !== null && refs[activeIndex]) {
    const item = refs[activeIndex]
    const src = srcFor(item)
    return (
      <div className="modal-body">
        <div className="d-flex align-items-center justify-content-between mb-3">
          <button className="btn btn-sm btn-outline-primary" onClick={backToGrid}>
            &larr; All screens
          </button>
          <div className="text-truncate px-2 text-center" style={{ flex: 1 }}>
            <strong>{item.name || `Screen ${activeIndex + 1}`}</strong>
            <span className="text-muted" style={{ marginLeft: "8px" }}>
              {activeIndex + 1} / {refs.length}
            </span>
          </div>
          <div className="flex-shrink-0">
            <button
              className="btn btn-sm btn-outline-primary"
              style={{ marginRight: "8px" }}
              onClick={showPrev}
              disabled={refs.length < 2}
            >
              Prev
            </button>
            <button
              className="btn btn-sm btn-outline-primary"
              onClick={showNext}
              disabled={refs.length < 2}
            >
              Next
            </button>
          </div>
        </div>
        {/* Fixed height so a tall screenshot scrolls inside instead of resizing the modal. */}
        <div style={{ height: "72vh", overflow: "auto", background: "#fafafa" }}>
          {src ? (
            <img src={src} alt={item.name} style={{ width: "100%", display: "block" }} />
          ) : (
            <div className="text-muted d-flex align-items-center justify-content-center h-100">
              Screenshot not available
            </div>
          )}
        </div>
      </div>
    )
  }

  // Grid of every screen for the order.
  return (
    <div className="modal-body">
      {refs.length === 0 && (
        <div className="text-muted text-center p-4">
          No screens available for this order.
        </div>
      )}

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(340px, 1fr))",
          gap: "16px",
          maxHeight: "76vh",
          overflowY: "auto",
          padding: "4px",
        }}
      >
        {refs.map((item, index) => {
          const src = srcFor(item)
          return (
            <div
              key={index}
              className="border rounded"
              style={{
                overflow: "hidden",
                background: "#fff",
                cursor: src ? "pointer" : "default",
              }}
              onClick={() => openViewer(index)}
              title={src ? "Click to enlarge" : ""}
            >
              <div
                className="px-3 py-2 border-bottom text-truncate"
                style={{ background: "#f8f9fa", fontWeight: 600, fontSize: "13px" }}
              >
                {item.name || `Screen ${index + 1}`}
              </div>
              <div
                style={{
                  height: "260px",
                  overflow: "hidden",
                  background: "#fafafa",
                }}
              >
                {src ? (
                  <img
                    src={src}
                    alt={item.name}
                    style={{ width: "100%", display: "block" }}
                  />
                ) : (
                  <div className="text-muted d-flex align-items-center justify-content-center h-100">
                    Screenshot not available
                  </div>
                )}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default ImageModal
